<template>
  <el-card shadow="never" class="portal-eChart-box">
    <div  class="portal-common-title">
      <span>{{ title }}{{ subTitle }}</span>
      
    </div>
    <div class="eChart-box-body">
      <div class="list-details" v-show="!isEmpty">
        <ul class="infinite-list"  style="overflow:auto">
          <li v-for="(i, index) in dataTodoList" 
          class="infinite-list-item" :key="index">
            <div>{{ i.itemContent }}</div>
            <div>{{ i.createTime }}</div>
          </li>
        </ul>
              
      </div>
      <div class="portal-common-noData portal-common-noData-eChart" v-show="isEmpty">
        <p class="noData-txt">暂无数据</p>
      </div>
      
    </div>
  </el-card>
</template>
<script>

import request from '@/config/request.js'
const ApiHome = request.Home
export default {
  
  props: {
    title: { type: String, default: '' },
    option: { type: Object, default: () => {} },
    propsApi: '',
    subTitle: ''
    
  },
  data() {
    return {
      isEmpty: true,
    dataTodoList: []
    
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      console.log(111)
      ApiHome.getTodoItems.call(this, {}, (list => {
        this.dataTodoList = list
        this.isEmpty = list.length > 0 ? false : true
      }))
    },
}
}
</script>

<style lang="less">
.el-card__body{
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  .portal-common-title{
    padding: 18px 20px;
    box-sizing: border-box;
  }
  .eChart-box-body {
    display: flex;
    flex: 1;
    height: 100%;
    .dom-canvas{
      flex: 1;
      width: 100%;
      div:nth-child(1){
        width: 100%;
      }
    }
    .list-details{
      flex-shrink: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      line-height: 30px;
      padding:0 20px;
      .infinite-list{
        list-style: none;
        margin: 0;
        padding: 0;
      }
      .infinite-list-item{
        position: relative;
        display: flex;
        flex-direction: column;
        background: #e9f3fb;
        border-radius: 8px;
        padding: 12px 16px 10px 28px;
        margin-bottom: 10px;
      }
      .infinite-list-item::before{
        content: '';
        position: absolute;
        left: 12px;
        top: 20px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #8aa4c9;
      }
      .infinite-list-item div:nth-child(1){
        color: #3c3938;
        font-size: 14px;
        line-height: 22px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-word;
      }
      .infinite-list-item div:nth-child(2){
        color: #919192;
        font-size: 12px;
        margin-top: 4px;
      }
      .dom-details-item{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        img{
          width: 47px;
          height: 47px;
        }
        div{
          margin-left: 3px;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          width: 100px;

          span{
            display: block;
            font-size: 14px;
            &:nth-child(1) {
              color: #3c3938;
            }
            &:nth-child(2) {
              color: #1a92ff;
            }
          }

        }
      }
    }
    .portal-common-noData-eChart{
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .dom-canvas{
    height: 100%;
  }
}


</style>
